import { defineModule } from '@berky/module-contract'

/**
 * Das Manifest ist die einzige Verbindung zwischen Modul und Shell.
 * Die Shell findet diese Datei selbst — sie muss nirgends eingetragen werden.
 */
export default defineModule({
  id: 'meilensteine',
  title: 'Meilensteine',
  description: 'Meilensteine in Projekten planen, freigeben und nachverfolgen.',
  icon: 'ListChecks',
  order: 30,
  apiBasePath: '/api/meilensteine',

  // Kein scopes-Feld: die Anmeldung an der API macht die Plattform. Sie kennt
  // den Bereich der Umgebung, in der sie gerade läuft — useApiClient() hängt
  // das passende Token von selbst an.

  roles: ['meilensteine.nutzer', 'meilensteine.admin'],

  routes: () => import('./src/routes'),

  // Optional: eine Kennzahl für die Kachel auf der Startseite.
  // homeWidget: () => import('./src/home-widget'),
})
